export const exteriorView01ImageOptions = {
  angle: 'ExteriorView01',
  staticOptions: {
    HullColorways: 1,
    HullTreatment: 1,
    BathingLadder: 1,
    CockpitLockers: 1,
    RemovableFootChocks: 1,
    RemovableCockpitTable: 1,
    RemovableCompass: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    Mainsail: 1,
    Flag: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'BathingLadder',
      dependency: null
    },
    {
      option: 'CockpitLockers',
      dependency: null
    },
    {
      option: 'RemovableFootChocks',
      dependency: null
    },
    {
      option: 'RemovableCockpitTable',
      dependency: null
    },
    {
      option: 'RemovableCompass',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    },
    {
      option: 'Mainsail',
      dependency: null
    }
  ],
  overlays: [
    {
      option: 'BathingLadder',
      dependency: null
    },
    {
      option: 'Flag',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xr41/views/ExteriorView01.js